import './src/styles/index.scss';

import { _wrapPageElement, _onClientEntry } from './wrapPageElement';

export const wrapPageElement = _wrapPageElement;
export const onClientEntry = _onClientEntry;
